import { createContext, useContext, useState } from 'react';
import { SelectedShortlistedProfile } from '../ShortlistedButtonActions';

type OutreachCandidate = Pick<SelectedShortlistedProfile, 'id' | 'name' | 'url' | 'emailSentCount'>;
export interface OutreachCandidatePopout {
    selectedProfile: OutreachCandidate[];
    openSendEmail: boolean;
    openSendEmailPopout: (candidates: OutreachCandidate[]) => void;
    openLinkedInMessage: boolean;
    openLinkedInMessagePopout: (candidates: OutreachCandidate[]) => void;
    closeOutreachPopout: () => void;
}

export const OutreachCandidatePopoutContext = createContext<OutreachCandidatePopout>(undefined!);

export const useOutreachCandidatePopoutContextProvider = (): OutreachCandidatePopout => {
    const [openSendEmail, setOpenEmailOutreach] = useState(false);
    const [openLinkedInMessage, setOpenLinkedInMessage] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState<OutreachCandidate[]>([]);

    const openSendEmailPopout = (candidates: OutreachCandidate[]) => {
        setSelectedProfile(candidates);
        setOpenEmailOutreach(true);
    };

    const openLinkedInMessagePopout = (candidates: OutreachCandidate[]) => {
        setSelectedProfile(candidates);
        setOpenLinkedInMessage(true);
    };

    const closeOutreachPopout = () => {
        setOpenEmailOutreach(false);
        setOpenLinkedInMessage(false);
    };

    return {
        selectedProfile,
        openSendEmail,
        openSendEmailPopout,
        openLinkedInMessage,
        openLinkedInMessagePopout,
        closeOutreachPopout,
    };
};

export const useOutreachCandidatePopoutContext = () => {
    const context = useContext(OutreachCandidatePopoutContext);

    if (!context) {
        throw new Error(
            'useOutreachCandidatePopoutContext must be used inside OutreachCandidatePopoutContext.Provider',
        );
    }

    return context;
};
